import MultipleChoicePoll from './multiple_choice_poll'
import Responds from './mixins/_responds'
import URI from 'urijs'

export default class RankingPoll extends MultipleChoicePoll {
  get defaultType () {
    return 'ranking_poll'
  }

  initialize (options = {}) {
    super.initialize(...arguments)

    this.include(Responds)

    /*
     * Needed for compatibility with old backbone stuff in Rails. See
     * `app/assets/javascripts/lib/backbone/models/poll.js.coffee` in the
     * rails app for details.
     * TODO: Remove this once the old backbone stuff in Rails has been removed.
     */
    this.model_type = this.type()
  }

  summaryTableUrl () {
    return undefined
  }

  responseUrl () {
    const permalink = this.get('permalink')
    return URI('/').segment(this.type() + 's').segment(permalink)
      .segment('results.json').toString()
  }

  sendToListUrl () {
    return undefined
  }
}
